import { STORE_BRANDING } from '../config/storeBranding';

export interface VehicleDescriptionData {
  brand?: string | null;
  model?: string | null;
  /** Texto do ano; na FIPE vem como "2014 Flex". */
  year?: string | number | null;
  color?: string | null;
  km?: string | number | null;
  cambio?: string | null;
  motor?: string | null;
}

const CAMBIO_LABELS: Record<string, string> = {
  manual: 'Manual',
  automatico: 'Automático',
  seletor: 'CVT',
};

// Na FIPE, ano acima disso significa veículo zero km (ex.: "32000 Flex").
const FIPE_ZERO_KM_YEAR = 3000;

const FUEL_PATTERN = /gasolina|[áa]lcool|etanol|flex|diesel|h[íi]brido|el[ée]trico/i;

const INTROS: ((name: string, store: string) => string)[] = [
  (name, store) => `${name} disponível na ${store}.`,
  (name, store) => `Procurando ${name}? Temos na ${store}.`,
  (name, store) => `Confira ${name} na ${store} e venha conhecer de perto.`,
];

/**
 * Monta a descrição pública só com dados do cadastro. Não afirma nada que o sistema
 * não sabe (revisão, único dono, financiamento): quem vende pode acrescentar depois.
 */
export function generateVehicleDescription(data: VehicleDescriptionData, variant = 0): string {
  const title = [data.brand, data.model].map((s) => (s || '').trim()).filter(Boolean).join(' ');
  if (!title) return '';

  const yearText = String(data.year ?? '');
  const yearNumber = Number(yearText.match(/\d{4,5}/)?.[0] ?? 0);
  const isZeroKm = yearNumber >= FIPE_ZERO_KM_YEAR;
  const name = [title, isZeroKm ? '0 km' : yearNumber || ''].filter(Boolean).join(' ');

  const km = Number(String(data.km ?? '').replace(/\D/g, ''));
  const fuel = yearText.match(FUEL_PATTERN)?.[0];
  const specs = [
    data.color?.trim() ? `Cor: ${data.color.trim()}` : '',
    km > 0 ? `Quilometragem: ${km.toLocaleString('pt-BR')} km` : '',
    data.cambio ? `Câmbio: ${CAMBIO_LABELS[data.cambio] || data.cambio}` : '',
    data.motor?.trim() ? `Motor: ${data.motor.trim()}` : '',
    fuel ? `Combustível: ${fuel}` : '',
  ].filter(Boolean);

  const intro = INTROS[Math.abs(variant) % INTROS.length](name, STORE_BRANDING.name);

  return [intro, specs.map((s) => `• ${s}`).join('\n'), 'Entre em contato e agende uma visita.']
    .filter(Boolean)
    .join('\n\n');
}

export const VEHICLE_DESCRIPTION_VARIANTS = INTROS.length;
